import axios from "axios";

const axiosInstance = axios.create();

const requestHandler = async (request) => {
  return request;
};

axiosInstance.interceptors.request.use(
  (config) => requestHandler(config),
  (err) => {
    return Promise.reject(err);
  }
);

const responseHandler = (error) => {
  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => responseHandler(error)
);

export default axiosInstance;
